









import {Prop} from 'vue-property-decorator';
import {Component, Vue} from '@/shared/component';

import storeTva from '@/stores/modules/tva';
import InputGenericEntitySelect from './GenericEntitySelect.vue';

@Component({
	components: {
		InputGenericEntitySelect
	}
})
export default class InputTva extends Vue {

	@Prop ({ type: Function, required: false, default: () => ( () => true ) }) private itemFilter!: () => boolean;
	
	store = storeTva;
}
